import axios from "axios";
import {closeAllKI_Image_Overlays} from "./KIOverlaySelectors";
import {AILogoToUserAccountAdder} from "./generateLogoFromPrompt";
import {LogoPoolController} from "../controllerModules/logoPoolController";
import {EventVerteiler} from "../../global/eventVerteiler";

export class KIlogoGenerationProgress {
    public static progress(progress: string) {

        if(progress === "done") {
            progress = "100";
        }
        if (!isNaN(parseInt(progress)) ) {
            (document.querySelector(".ki-loading-progress-bar") as HTMLElement).style.display = "block";
            (document.querySelector("#ki_loading_status") as HTMLElement).style.display = "none";
            (document.querySelector(".ki-loading-progress-bar-fill") as HTMLElement).style.width = progress + "%";
        } else {
            (document.querySelector(".ki-loading-progress-bar") as HTMLElement).style.display = "none";
            (document.querySelector("#ki_loading_status") as HTMLElement).style.display = "block";
            (document.querySelector("#ki_loading_status") as HTMLElement).textContent = progress;
        }
    }

    public static finished(currentPrompt:string, id:number, imagetextBase64:string, preset) {
        document.querySelector("#ki_loading_status").textContent = "";
        document.querySelector("#ki_result_prompt").textContent = currentPrompt;
        (document.querySelector("#ki_result") as HTMLDivElement).innerHTML = "<img alt='ailogo result' id='" + id + "' src='data:image/png;base64," + imagetextBase64 + "'>";
        document.getElementById("download_ai_logos").addEventListener("click", () => AILogoToUserAccountAdder.putImagesIntoLogoBibliothek(id, preset))
    }


}

export class AILogoToUserAccountAdderProgress {
    private static lastprogress: string;

    public static init() {
        document.getElementsByClassName("ki-loading-title")[0].classList.remove("ele-hidden");
        const template = document.getElementById("kilogo_upscale_template") as HTMLTemplateElement;
        const clone = template.content.cloneNode(true);
        const upscaleProgress = document.getElementById("ki_logo_upscale_progress");
        document.getElementsByClassName("ki-text-freigestellt")[0]?.classList.add("ele-hidden");
        upscaleProgress.innerHTML ="";
        upscaleProgress.append(clone);
    }

    public static progress(progress: string) {
        if(AILogoToUserAccountAdderProgress.lastprogress === progress) {
            return;
        }
        AILogoToUserAccountAdderProgress.lastprogress = progress;
        let element = document.querySelector("#upscaleprogress");
        const paragraphs = document.getElementsByClassName('upscaleprogresstext');
        for(let paragraph of paragraphs) {
            if(paragraph.classList.contains("disappear")) {
                continue;
            }
            paragraph.classList.add("disappear");
            setTimeout(()=>paragraph.parentNode.removeChild(paragraph), 2000);
        }
        const newElement = document.createElement("p");
        newElement.textContent = progress;
        newElement.classList.add('upscaleprogresstext');
        element.appendChild(newElement);
    }
    public static finished(logourl:string|null, bgRemovedurl:string|null) {
        document.getElementsByClassName("ki-loading-title")[0].classList.add("ele-hidden");
        document.getElementById("upscaleprogress").classList.add("ele-hidden");
        if(bgRemovedurl !== "") {
            document.getElementById("upscaledimage_bgremoved_container").classList.remove("ele-hidden");
            document.getElementsByClassName("ki-text-freigestellt")[0].classList.remove("ele-hidden");
        }
        axios.get(logourl, {responseType:"blob"}).then(response=>{
            (document.getElementById("upscaledimage") as HTMLImageElement).src= URL.createObjectURL(response.data);
        });
        if(bgRemovedurl !== "") {
            axios.get(bgRemovedurl, {
                responseType: 'blob',
                timeout: 30000,
            }).then(response=>{
                (document.getElementById("upscaledimage_bgremoved") as HTMLImageElement).src= URL.createObjectURL(response.data);
            });
        }

        (document.getElementById("upscaledimage") as HTMLImageElement).src= logourl;
        (document.getElementById("upscaledimage_bgremoved") as HTMLImageElement).src= bgRemovedurl;
        const bgremoved_ok = document.getElementById("bgremoved_ok");
        bgremoved_ok.classList.remove("ele-hidden");
        bgremoved_ok.onclick=function() {
            closeAllKI_Image_Overlays();
        }

        EventVerteiler.broadcast("testIfLogoPoolIsUpToDateEvent");
    }
}

